export default __webpack_public_path__ + "static/media/img6.5838fca6.jpg";